<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard --statistics">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Štatistiky -->
                    <div v-if="profil.pouzivatel_id" class="col-xs-12 col-md-12 col-lg-8 col-xl-9">
                        <h2>Štatistiky</h2> 

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <!-- Category phone -->
                        <div class="d-md-none mb-4">
                            <select class="custom-select" id="inputGroupSelect01" @change="onChange($event.target.value)">
                                <option value="0">Najviac zadaných EAN kódov celkom</option>
                                <option value="1">Najviac zadaných rôznych EAN kódov</option>
                                <option value="2">Najšťastnejšia kravička</option>
                            </select>
                        </div>

                        <!-- Category -->
                        <ul class="nav nav-tabs d-none d-md-flex" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a @click="changeStatistics('pocet_ean_aktualny_mesiac'); selected(0)" :class="'nav-link show' + [tab == 0 ? ' active' : '']">Najviac zadaných<br> EAN kódov celkom</a>
                            </li>
                            <li class="nav-item">
                                <a @click="changeStatistics('pocet_roznych_ean_aktualny_mesiac'); selected(1)" :class="'nav-link show' + [tab == 1 ? ' active' : '']">Najviac zadaných<br> rôznych EAN kódov</a>
                            </li>
                            <li class="nav-item">
                                <a @click="changeCowStatistics('stastie_aktualny_mesiac'); selected(2)" :class="'nav-link show' + [tab == 2 ? ' active' : '']">Najšťastnejšia<br> kravička</a>
                            </li>
                        </ul>

                        <!-- Tabs -->
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="najviacEan" role="tabpanel" aria-labelledby="najviacEan-tab">

                                <!-- Header -->
                                <div v-if="tab == 0" class="row align-items-center mb-3">
                                    <div class="col-md-8">
                                        <h4 class="mb-2 mb-md-0">Najviac zadaných EAN kódov celkom</h4>
                                    </div>
                                    <div class="col-md-4 text-left text-md-right">
                                        <select id="si" class="custom-select" @change="changeStatistics($event.target.value)">
                                            <option value="pocet_ean_aktualny_mesiac">Aktuálny mesiac</option>
                                            <option value="pocet_ean_minuly_mesiac">Minulý mesiac</option>
                                            <option value="pocet_ean_predminuly_mesiac">Predminulý mesiac</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-else-if="tab == 1" class="row align-items-center mb-3">
                                    <div class="col-md-8">
                                        <h4 class="mb-2 mb-md-0">Najviac zadaných rôznych EAN kódov</h4>
                                    </div>
                                    <div class="col-md-4 text-left text-md-right">
                                        <select id="si" class="custom-select" @change="changeStatistics($event.target.value)">
                                            <option value="pocet_roznych_ean_aktualny_mesiac">Aktuálny mesiac</option>
                                            <option value="pocet_roznych_ean_minuly_mesiac">Minulý mesiac</option>
                                            <option value="pocet_roznych_ean_predminuly_mesiac">Predminulý mesiac</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-else class="row align-items-center mb-3">
                                    <div class="col-md-8">
                                        <h4 class="mb-2 mb-md-0">Najšťastnejšia kravička</h4>
                                    </div>
                                    <div class="col-md-4 text-left text-md-right">
                                        <select id="si" class="custom-select" @change="changeCowStatistics($event.target.value)">
                                            <option value="stastie_aktualny_mesiac">Aktuálny mesiac</option>
                                            <option value="stastie_minuly_mesiac">Minulý mesiac</option>
                                            <option value="stastie_predminuly_mesiac">Predminulý mesiac</option>
                                        </select>
                                    </div>
                                </div>

                                <!-- Content -->
                                <div class="row">
                                    <div class="col-md-12">
                                        <table class="statisticsTable">
                                            <thead>
                                                <tr v-if="tab != 2">
                                                    <th>#</th>
                                                    <th>Hráč</th>
                                                    <th class="text-right">Počet ean kódov</th>
                                                    <th class="text-right">Počet kravičiek</th>
                                                </tr>
                                                <tr v-else>
                                                    <th>#</th>
                                                    <th>Hráč</th>
                                                    <th class="text-right">Kravička</th>
                                                    <th class="text-right">Priemerné šťastie</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="pouzivatel_statistiky" v-for="(item, index) in statistiky">
                                                    <td>{{ index + 1 }}</td>
                                                    <td class="name">{{ item.pouzivatel_meno }}</td>
                                                    <td class="text-right">{{ item[column] }}</td>
                                                    <td class="count-cows text-right">{{ item.pocet_kraviciek }}</td>
                                                </tr>
                                                <tr v-else>
                                                    <td>{{ index + 1 }}</td>
                                                    <td class="name">{{ item.pouzivatel_meno }}</td>
                                                    <td class="text-right">{{ item.kravicka_meno }}</td>
                                                    <td class="count-cows text-right">{{ item[column] }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <!-- .Content -->
                            </div>
                        </div>
                        <!-- .Tabs -->

                    </div>
                    <!-- .Štatistiky -->

                </div>
            </div>
        </main>
        <!-- .Main -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    export default {
        components: {
            HeaderProfil,
            MenuProfil
        },
        props: [
            'profil',
            'spravy'
        ],
        mounted() {
            this.getStatistiky(this.column)
        },
        updated() {
            if (this.updated == 0) {
                this.getStatistiky(this.column)
            }
        },
        data() {
            return {
                column: 'pocet_ean_aktualny_mesiac',
                statistiky: [],
                pouzivatel_statistiky: true,
                tab: 0,

                updated: 0,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted
            getStatistiky(column) {
                if (typeof(this.profil.pouzivatel_id) != 'undefined' && this.profil.id != 0) {
                    this.updated = 1

                    EventService.getStatistiky(column, this.profil.pouzivatel_id.pouzivatel_group)
                        .then(response => {
                            //console.log(response.data)
                            this.statistiky = response.data.data
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })       
                }
            },


            // click
            selected(tab) {
                this.tab = tab
                document.getElementById('si').selectedIndex = '0'
            },

            changeStatistics(column) {
                this.column = column
                this.pouzivatel_statistiky = true
                this.getStatistiky(this.column)
            },

            changeCowStatistics(column) {
                this.column = column
                this.pouzivatel_statistiky = false
                this.getKravickaStatistiky(this.column)
            },

            getKravickaStatistiky(column) {
                EventService.getKravickaStatistiky(column, this.profil.pouzivatel_id.pouzivatel_group)
                    .then(response => {
                        //console.log(response.data)
                        this.statistiky = response.data.data
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },


            // select
            onChange(value) {
                this.selected(value)
                if (value == 0) {
                    this.changeStatistics('pocet_ean_aktualny_mesiac')
                } else if(value == 1) {
                    this.changeStatistics('pocet_roznych_ean_aktualny_mesiac')
                } else {
                    this.changeCowStatistics('stastie_aktualny_mesiac')
                }
            }
        }
    }
</script>